query Poll($id: ID!) {
  poll(id: $id) {
    id
    question
    options {
      id
      text
      isCorrect
    }
    isMultiple
    resultsMode
    usage {
      attachmentsCount
      isLocked
    }
    createdAt
    updatedAt
  }
}
